import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { GeneralPropertyTabComponent, GenericPropertyTabComponent } from "./genericNodePropertyComponent";
import { LineContainerComponent } from "shared-ui-components/lines/lineContainerComponent";
import { TextLineComponent } from "shared-ui-components/lines/textLineComponent";
export class DebugPropertyTabComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this._onUpdateRequiredObserver = this.props.stateManager.onUpdateRequiredObservable.add(() => {
            this.forceUpdate();
        });
    }
    componentWillUnmount() {
        this._onUpdateRequiredObserver?.remove();
        this._onUpdateRequiredObserver = null;
        this._dataCollectedObserver?.remove();
        this._dataCollectedObserver = null;
    }
    render() {
        const debugBlock = this.props.nodeData.data;
        if (this._dataCollectedObserver) {
            this._dataCollectedObserver.remove();
        }
        this._dataCollectedObserver = debugBlock.onDataCollectedObservable.add((data) => {
            this.forceUpdate();
        });
        return (_jsxs("div", { children: [_jsx(GeneralPropertyTabComponent, { stateManager: this.props.stateManager, nodeData: this.props.nodeData }), _jsx(GenericPropertyTabComponent, { stateManager: this.props.stateManager, nodeData: this.props.nodeData }), _jsx(LineContainerComponent, { title: "DEBUG INFOS", children: debugBlock.log.map((str, i) => {
                        return _jsx(TextLineComponent, { label: i + " >", value: str[0], tooltip: str[1] }, i);
                    }) })] }));
    }
}
//# sourceMappingURL=debugNodePropertyComponent.js.map